import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=0aa59286&scoped=true&"
import script from "./LoginButton.vue?vue&type=script&lang=js&"
export * from "./LoginButton.vue?vue&type=script&lang=js&"
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=0aa59286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa59286",
  null
  
)

export default component.exports